import styles from "./StandartedTextRow.module.css"

const StandartedTextRowV6 = ({
  title=<></>,
  subtitle=<></>,
  addition=<></>,
  children=<></>
}) => {
  return(
    <div className={styles.wrapper}>
      <div className={styles.title}>{title}</div>
      <div className={styles.right}>
        <div className={styles.subtitle}>{subtitle}</div>
        <div className={styles.addition}>{addition}</div>
      </div>
      {children}
    </div>
  )
}

export default StandartedTextRowV6;